import type { AdSlotState } from "scmp-app/components/advertisement/ad-slots/top-banner-ad-slot/atoms";
import { TargetingPaidType } from "scmp-app/components/advertisement/ad-slots/types";

import { SubSectionTopAdBannerConfigTemplate } from "./consts";

export const createTopAdBannerConfig = (
  templateKey: keyof typeof SubSectionTopAdBannerConfigTemplate,
  entityId: string,
  zone: string,
): AdSlotState => {
  const template = SubSectionTopAdBannerConfigTemplate[templateKey];

  const commonTargeting = {
    paid: TargetingPaidType.NotArticle,
    scsid: [entityId],
    ...template.extraTargeting,
  };

  return {
    desktop: {
      adUnit: "d_banner1",
      sizes: template.desktopSizes as [number, number][],
      targeting: commonTargeting,
      zone,
    },
    mobile: {
      adUnit: "m_banner3",
      sizes: template.mobileSizes as [number, number][],
      targeting: commonTargeting,
      zone,
    },
  };
};
